import React, { useMemo } from 'react';

import { Outlet, useNavigation } from 'react-router-dom';

import { useAppSelector, useProfile } from '@pkg/hooks';

import { NavigationState } from '@app/routes/types';
import { useAuthTokens } from '@app/store/zustand/auth/useAuthTokens';

export const PublicRoute = ({
    ejectAuthenticated = false,
    reactive = true,
}: { ejectAuthenticated?: boolean; reactive?: boolean } = {}) => {
    const navigation = useNavigation();
    const { isAuthenticated } = useAuthTokens();
    const { redirectToProfile } = useProfile();

    const isRegisteredUser = useAppSelector((state) => state.user.isRegisteredUser);

    const shouldRedirect_NonReactive = useMemo(() => {
        return isAuthenticated && isRegisteredUser && navigation.state === NavigationState.Idle && ejectAuthenticated;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const shouldRedirect_Reactive =
        isAuthenticated && isRegisteredUser && navigation.state === NavigationState.Idle && ejectAuthenticated;

    if ((shouldRedirect_Reactive && reactive) || (shouldRedirect_NonReactive && !reactive)) {
        redirectToProfile({ hardRedirect: true });
        return null;
    } else {
        return <Outlet />;
    }
};
